import { componentsDeclarations } from "./components"
import { getUuid } from "./helpers/get-uuid"

function initComponents() {
  const attribute = "data-component"

  document.querySelectorAll(`[${attribute}]`).forEach((element) => {
    const componentName = element.getAttribute(attribute)

    const componentInstance = new componentsDeclarations[componentName]({
      $componentName: componentName,
      $el: element,
      $uuid: getUuid(),
    })

    // Initialize '$ui'
    componentInstance.ui()
    componentInstance.$ui = Object.entries(componentInstance.ui()).reduce(
      (acc, [name, selector]) => {
        const elements = componentInstance.$el.querySelectorAll(selector)

        if (elements.length === 1) {
          acc[name] = elements[0]
        } else if (elements.length > 1) {
          acc[name] = elements
        }

        return acc
      },
      {}
    )

    // Run 'created'
    // setTimeout to break the work into small units
    setTimeout(() => {
      componentInstance.created()
    })
  })
}

initComponents()
